


















import { Vue, Component, Prop } from 'vue-property-decorator'
import { ChartData, ChartOptions } from 'chart.js'
import { ENQUETE_CHART_BACKGROUND_COLORS } from '@/constants/ux-constants'

@Component({
  components: {
    SmText: () => import('@/components/atoms/SmText.vue'),

    SmChartPie: () => import('@/components/molecules/SmChartPie.vue'),
  }
})

export default class SmChartUnionReportPie extends Vue {
  @Prop({ required: true, default: '' })
  label!: string

  @Prop({ required: true, default: () => [] })
  voteResult!:number[]

  private get total(): number {
    return this.voteResult.reduce((sum, element) => sum + element, 0)
  }

  /**
   * dataに円グラフに表示させる情報を配列で入れる
   * backgroundColorはdataと同じindexの背景色
   */
  private get chartData(): ChartData {
    const percentagedData = this.voteResult.map(e => this.getPercentage(e, this.total))
    return {
      datasets: [
        {
          type: 'pie',
          backgroundColor: ENQUETE_CHART_BACKGROUND_COLORS,
          borderAlign: 'center',
          borderColor: undefined,
          borderWidth: 0,
          data: percentagedData,
        },
      ]
    }
  }

  /**
   * 実数値をパーセンテージ（少数第一位四捨五入）に変換
   */
  private getPercentage(elementNum: number, total: number): number {
    if (total === 0) return 0
    if (elementNum === 0) return 0
    return Math.round(elementNum / total * 100)
  }

  /**
   * responsive:trueとmaintainAspectRatio:falseにすることでstyleでグラフサイズをstyleで指定することが可能
   * 凡例は既存のコンポーネントで表示想定のため、dispay:falseに設定
   * カーソル当たるとパーセンテージが表示されるので、tooltipsで表示させないよう制御
   * devicePixelRatioはグラフをPDFで出力する際にグラフが荒く表示されてしまうため、2に設定
   * pluginsはdatalabels（グラフ上に文字を表示させるプラグイン）のみ使用可能。外部から色等を指定するのは厳しそうなので、colorやfontを指定してあげる必要あり
   */
  private get chartOptions(): ChartOptions {
    return {
      responsive: true,
      maintainAspectRatio: false,
      responsiveAnimationDuration: 0,
      legend: {
        display: false
      },
      tooltips: {
        enabled: false
      },
      devicePixelRatio: 2,
      plugins: {
        datalabels: {
          color: this.total === 0 ? 'black' : 'white',
          font: {
            weight: 'bold'
          },
          formatter: function(value: number): string { return value + '%' }
        }
      },
    }
  }
}
